import { useEffect, useState } from 'react';

const DOT_INTERVAL_MS = 600;
const MAX_DOTS = 3;

const useAnimatedDots = (active: boolean): string => {
  const [dots, setDots] = useState<number>(1);

  useEffect(() => {
    if (!active) {
      setDots(1);
      return;
    }
    const interval = setInterval(() => {
      setDots((d) => (d % MAX_DOTS) + 1);
    }, DOT_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [active]);

  return '.'.repeat(dots);
};

export default useAnimatedDots;
